enum ButtonThemes {
    Bad = "bad",
    Normal = "normal",
    OK = "ok",
    Minimal = "minimal",
    Theme = "theme",
    Auth = "auth",
    Link = "link",
    None = "none"
}

export default ButtonThemes;

export type ButtonTheme = ButtonThemes.Bad | ButtonThemes.Normal | ButtonThemes.OK | ButtonThemes.Minimal | ButtonThemes.Theme | ButtonThemes.Auth | ButtonThemes.Link | ButtonThemes.None;